import React from 'react';
import { RevenueCalculator } from './components/RevenueCalculator';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <header className="w-full bg-indigo-700 text-white py-6 sm:py-8 px-4 sm:px-6 shadow-lg" data-id="element-1">
        <div className="max-w-6xl mx-auto" data-id="element-2">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6" data-id="element-3">
            <div className="text-center md:text-left w-full md:w-auto" data-id="element-4">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-2" data-id="element-5">
                WELCOME TO SCALINGMATH.COM
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl font-medium text-indigo-100" data-id="element-6">
                WANT TO SCALE? DO THE MATH.
              </p>
            </div>
            <div className="w-36 h-36 sm:w-48 sm:h-48 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-white shadow-md flex-shrink-0 mx-auto md:mx-0" data-id="element-7">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9XyiAsYHPxY3ZSUZWYypWQ/360_F_168419369_XM588ym4hm0fKtKSZ7rjnpsCUIm5Xc3v.jpg" alt="Business man with money" className="w-full h-full object-cover" data-id="element-8" />
            </div>
          </div>
        </div>
      </header>
      <RevenueCalculator data-id="element-9" />
    </div>;
}